import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCurrentLevelPlaceMark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 24,
	viewBox: "0 0 28 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 12C1 5.92487 5.92487 1 12 1C13.5417 1 15.0108 1.3194 16.3447 1.89355L16.3457 1.89258C17.5781 2.41777 18.6962 3.1575 19.6504 4.06445L19.6562 4.07031L19.6631 4.07617L25.834 10.1533L25.835 10.1523C26.0788 10.3917 26.2727 10.6771 26.4053 10.9922C26.5376 11.3069 26.6061 11.6458 26.6064 11.9883C26.6067 12.3304 26.539 12.6693 26.4072 12.9844C26.2754 13.2994 26.0822 13.5854 25.8389 13.8252L25.8379 13.8252L19.6641 19.9229L19.6572 19.9297L19.6504 19.9355C18.6945 20.8442 17.5744 21.5849 16.3389 22.1104L16.3379 22.1094C16.2972 22.1268 16.2576 22.1451 16.2236 22.1592L16.2207 22.1602C16.2158 22.1622 16.2106 22.164 16.2012 22.168C16.1937 22.1711 16.1834 22.176 16.1719 22.1807L15.6836 22.3672C14.5311 22.7768 13.2908 23 12 23C5.92487 23 1 18.0751 1 12Z",
		fill: "#1257DD",
		stroke: "white",
		strokeWidth: 2
	})
});
export default SvgCurrentLevelPlaceMark;
